enum AuthRoutes {
  ADMIN = '/admin',
  ADMIN_BULK_IMPORT = '/admin/:orgId/bulk-import',
  BOARD = '/boards/:boardId',
  BOARDS = '/boards',
  CAMPAIGN = '/campaigns/:campaignId',
  CAMPAIGNS = '/campaigns',
  CAMPAIGN_DONATIONS = '/campaigns/:campaignId/donations',
  CAMPAIGN_EVENTS = '/campaigns/:campaignId/events',
  CAMPAIGN_EVENT = '/campaigns/:campaignId/events/:eventId',
  CAMPAIGN_FEED = '/campaigns/:campaignId/history/:historyId?',
  COMPANY = '/company',
  COMPANY_ADMIN = '/company/admin',
  COMPANY_AUTOMATIONS = '/company/automations',
  COMPANY_CONFIDENCE_LEVELS = '/company/confidence-levels',
  COMPANY_CUSTOM_FIELDS = '/company/custom-fields',
  COMPANY_DATA_UPLOADS = '/company/data-uploads',
  COMPANY_DATA_UPLOADS_NEW = '/company/data-uploads/new',
  COMPANY_DATA_UPLOADS_MATCH_HEADERS = '/company/data-uploads/:bulkImportId/match-headers',
  COMPANY_INVITES = '/company/invites',
  COMPANY_DATA_UPLOADS_REVIEW = '/company/data-uploads/:bulkImportId/review',
  COMPANY_LABELS = '/company/labels',
  COMPANY_TEAM = '/company/team',
  CONSTITUENT = '/constituent/:constituentId',
  CONSTITUENTS = '/constituents',
  CONSTITUENT_DONATIONS = '/constituent/:constituentId/donations/:donationId?',
  CONSTITUENT_EDIT = '/constituent/:constituentId/edit',
  CONSTITUENT_HISTORY = '/constituent/:constituentId/history/:historyId?',
  CONSTITUENT_INFO = '/constituent/:constituentId/info',
  CONSTITUENT_IWAVE = '/constituent/:constituentId/iwave',
  CONSTITUENT_NEW = '/new-constituent/:constituentType(prs|org)',
  CONSTITUENT_TASKS = '/constituent/:constituentId/tasks/:taskId?',
  DONORS = '/donors',
  FEATURE_FLAG_MANAGEMENT = '/admin/feature-flags',
  FEED = '/feed/:id',
  INTEGRATION = '/integrations/:integrationId',
  INTEGRATIONS = '/integrations',
  IWAVE_AUTH_CALLBACK = '/auth/iwave/callback',
  LANDING = '/',
  OPPORTUNITIES = '/opportunities',
  ORG_MANAGEMENT = '/admin/organizations',
  REPORTS = '/reports',
  SALESFORCE_INTEGRATION = '/integrations/salesforce',
  SALESFORCE_INTEGRATION_DEFINE_FILTERS = '/integrations/salesforce/define-filters',
  SALESFORCE_INTEGRATION_REVIEW_IMPORT = '/integrations/salesforce/review-import',
  TASK = '/tasks/:taskId',
  TASKS = '/tasks',
  USER = '/user',
  USER_DOWNLOADS = '/user/downloads',
}

export default AuthRoutes;
